module.exports = require("./as.d.ts");